import { render, staticRenderFns } from "./NewApp.vue?vue&type=template&id=43c67b22&scoped=true"
import script from "./NewApp.vue?vue&type=script&lang=js"
export * from "./NewApp.vue?vue&type=script&lang=js"
import style0 from "./NewApp.vue?vue&type=style&index=0&id=43c67b22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c67b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c67b22')) {
      api.createRecord('43c67b22', component.options)
    } else {
      api.reload('43c67b22', component.options)
    }
    module.hot.accept("./NewApp.vue?vue&type=template&id=43c67b22&scoped=true", function () {
      api.rerender('43c67b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewApp/NewApp.vue"
export default component.exports